export const px2vw = (size, width = 720) => `${(size / width) * 100}vw`;
